import React from "react";

// react-bootstrap components
import {
    Col,
    Row
} from "react-bootstrap";
import TotalEnrollInsights from "./TotalEnrolInsights";

function InsightCharts() {
    return (
        <>
            <Row>
                <Col lg="12" sm="6">
                    <TotalEnrollInsights />
                </Col>
            </Row>
        </>
    );
}

export default InsightCharts;
